import React, { Component, Fragment } from "react";
import styles from "./index.module.scss";
import { customize_purpose, flow, recommendProducts, caseShowList } from "@/config/config";
import Swiper from './components/Swiper';
import ReactSwipe from 'react-swipes';

// export default function Index() {
class Index extends Component {
  render() {
    const opt = {
      distance: 84, //每次移动的距离，卡片的真实宽度
      autoPlay: false, //是否开启自动播放
      swTouchstart: (ev) => {},
      swTouchmove: (ev) => {},
      swTouchend: (ev) => {
        // let data = {
        //   moved: ev.moved,
        //   originalPoint: ev.originalPoint,
        //   newPoint: ev.newPoint,
        //   calcelled: ev.calcelled
        // }
      }
    };
    return (
      <div>
        <section className={`${styles.banner} ${styles.top_banner}`}>
          <img
            className={styles.banner_img}
            src="/images/top_banner.jpg"
            alt="banner"
          />
        </section>
        <section className={styles.advantage_container}>
          <section className={styles.left_img}>
            <img src="/images/customization/customize_left.png" alt="" />
          </section>
          <section className={styles.advantage}>
            <div className={styles.title}>定制优势</div>
            <div className={styles.desc}>
              为产品赋予个性化标签，加深品牌印象
              借美好的茶具，传达愿对方健康的意愿
              在产品的使用过程中，增强和客户的联结
            </div>
            <div className={styles.btn}>
              <a href="https://yaji.tmall.com/p/rd052556.htm?spm=a1z10.1-b-s.w5001-15494666527.13.26ef75cfkOJ7PE&scene=taobao_shop" target="view_window">立 即 定 制</a>
            </div>
          </section>
          <section className={styles.right_img}>
            <img src="/images/customization/customize_right.png" alt="" />
          </section>
        </section>
        <section className={styles.purpose_wrapper}>
          <section className={styles.purpose_container}>
            {customize_purpose.map(item => (
              <section key={item.desc} className={styles.purpose_content}>
                <div className={styles.title}>{item.title}</div>
                <div className={styles.desc}>{item.desc}</div>
              </section>
            ))}
          </section>
        </section>
        <section className={styles.flow_container}>
          <div className={styles.title}>定制流程</div>
          {flow.map((item, index) => (
            <Fragment key={item.title}>
              <div className={styles.text}>{item.title}</div>
              {index < flow.length - 1 ? (
                <img
                  className={styles.circle}
                  src="/images/customization/circle.png"
                  alt=""
                />
              ) : null}
            </Fragment>
          ))}
        </section>
        <section className={styles.recommend_container}>
          <div className={styles.recommend_wrapper}>
            <div className={styles.title}>
              <span>选品推荐</span>
            </div>
            <div className={styles.recommend_product}>
              {recommendProducts.map(item => (
                <div key={item.title} className={styles.product_pic}>
                  <img src={item.pic} alt="" />
                  <span className={styles.text}>{item.title}</span>
                </div>
              ))}
            </div>
          </div>
        </section>
        <section className={styles.examples_container}>
          <div className={styles.title}>
            <span>案例展示</span>
          </div>
          <div className={styles.swiper}>
            <Swiper list={caseShowList} />
          </div>
          <div className={styles.app_swiper}>
            <ReactSwipe className={styles.app_slide_container} options={opt}>
              {caseShowList.map(item => (
                <div key={item.key} className={styles.app_slide_item}>
                  <img src={item.photo} alt=""/>
                  <span>{item.title}</span>
                </div>
              ))}
            </ReactSwipe>
          </div>
        </section>
        <section className={styles.company_container}>
          <div className={styles.title}>
            <span>部分合作企业</span>
          </div>
          <div className={styles.company_content}>
            <img src="/images/customization/company.png" alt="" />
          </div>
        </section>
        <div className={styles.app_footer}>
            <div className={styles.app_img_container}>
              <img src="/images/logo.png" alt=""/>
            </div>
            <div className={styles.app_info_container}>
              <div className={styles.app_info}>
                <div>杭州雅集茶具有限公司</div>
                <a href="http://beian.miit.gov.cn" target="_black" style={{ color: 'rgba(0, 0, 0, .65)' }}>浙ICP备11028005号-2</a>
              </div>
              <div className={styles.app_info}>
                <div>雅集专线:0571-86551555</div>
                <div>浙公网安备 33010802004971号</div>
              </div>
            </div>
          </div>
      </div>
    );
  }
}

export default Index;
